import axios, { AxiosResponse } from 'axios';

import iClinicApi from 'services/iclinic/iClinicApi';
import {
  CategoryResponse,
  OptInRequestPayload,
  OptInResponse,
  PharmasResponse,
} from '../types';

export const iclinicApp = axios.create({
  baseURL: process.env.ICLINIC_APP_URL,
});

export const setFreeSamplesOptIn = (
  payload: OptInRequestPayload,
): Promise<AxiosResponse<OptInResponse>> =>
  iclinicApp.post<OptInResponse>('/amostras-gratis/request-waiting/', payload);

export const getPharmas = () =>
  iClinicApi.get<PharmasResponse>('/free-samples/pharmaceuticals/?limit=0');

export const getCategories = () =>
  iClinicApi.get<CategoryResponse>('/free-samples/therapeutic-categories/');

export const sendIntercomEvent = (event: string) =>
  iClinicApi.post<string>('/free-samples/update-step-opt-in/', {
    step: event,
  });
